/**
 * Mini App startParam vocabulary (ADR + live payment return prefixes).
 * Shared with task 13 (`product_`); order/ok/fail are payment return hints.
 */

export type StartParamIntent
  = | { kind: 'order', orderId: number }
    | { kind: 'product', productId: number }
    | { kind: 'none' }

const ORDER_PREFIXES = ['order_', 'ok_', 'fail_'] as const

/**
 * Parse the launch `startParam`. Unknown / garbage / invalid id → `none`
 * (catalog shell; never an auth/gate failure).
 */
export function parseStartParam(
  raw: string | null | undefined,
): StartParamIntent {
  if (!raw?.trim()) {
    return { kind: 'none' }
  }

  const value = raw.trim()

  for (const prefix of ORDER_PREFIXES) {
    if (!value.startsWith(prefix)) {
      continue
    }
    const id = parsePositiveIntId(value.slice(prefix.length))
    if (id == null) {
      return { kind: 'none' }
    }
    return { kind: 'order', orderId: id }
  }

  if (value.startsWith('product_')) {
    const id = parsePositiveIntId(value.slice('product_'.length))
    if (id == null) {
      return { kind: 'none' }
    }
    return { kind: 'product', productId: id }
  }

  return { kind: 'none' }
}

function parsePositiveIntId(digits: string): number | null {
  if (!/^\d+$/.test(digits)) {
    return null
  }
  const id = Number(digits)
  if (!Number.isSafeInteger(id) || id <= 0) {
    return null
  }
  return id
}
